import { isInApp, openUrlInBrowser } from "@/libs/comeAppSDK";


export function openLink(url: string) {
  if (url) {
    if (isInApp()) {
      openUrlInBrowser(url);
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
      }, 0);
    }
  }
}
